/* Shared Subscription Card JS */

/* Variables to hold swiper instances - using objects to map by container ID if needed, 
   or just distinct variables if we know we only have these two specific cases. 
   To support both existing simultaneously or independently, we can check for existence. */
var plan_swiper; 
var plan_swiper_custom;
var card_swipers_group = []; // Array to hold all card image swipers
function manageCarouselAutoplay(swiperInstances) {
    if (typeof swiperInstances !== 'undefined') {
        var swipers = Array.isArray(swiperInstances) ? swiperInstances : [swiperInstances];
        
        swipers.forEach(function(sw) {
            if (sw && sw.el) {
                // Replacing $(sw.el).closest('.SubCard') with native element.closest()
                var card = sw.el.closest('.SubCard');
                
                // Replacing card.hasClass('selected') with classList.contains()
                if (card && card.classList.contains('selected')) {
                    if (sw.autoplay && typeof sw.autoplay.start === 'function') {
                        sw.autoplay.start();
                    }
                } else {
                    if (sw.autoplay && typeof sw.autoplay.stop === 'function') {
                        sw.autoplay.stop();
                    }
                    if (typeof sw.slideTo === 'function') {
                        sw.slideTo(0);
                    }
                }
            }
        });
    }
}

function equalizeCardHeights() {
    var cards = document.querySelectorAll('.SubCard');
    if (cards.length === 0) return;

    // 1. Reset min-height to allow natural measurement
    cards.forEach(function(card) {
        card.style.minHeight = 'auto';
    });

    // 2. Measure max height (offsetHeight includes padding & borders, like outerHeight())
    var maxHeight = 0;
    cards.forEach(function(card) {
        var h = card.offsetHeight;
        if (h > maxHeight) {
            maxHeight = h;
        }
    });

    // 3. Apply max height as min-height
    if (maxHeight > 0) {
        cards.forEach(function(card) {
            card.style.minHeight = maxHeight + 'px';
        });
    }
}

// Global functions for Swiper callbacks if they rely on string names in HTML data-attributes
// The HTML uses data-callback="slide_to_plan" or "slide_to_plan_custom"
function slide_to_plan(input_value, tab_element) {
    if (typeof plan_swiper === "undefined" || !plan_swiper || !tab_element) return;

    // Get the element's index among its siblings (replaces tab_element.index())
    var index = Array.prototype.indexOf.call(tab_element.parentNode.children, tab_element);

    if (index !== -1 && typeof plan_swiper.slideTo === 'function') {
        plan_swiper.slideTo(index, 500, true);
    }
}

function slide_to_plan_custom(input_value, tab_element) {
    if (typeof plan_swiper_custom === 'undefined' || !plan_swiper_custom || !tab_element) return;

    // Get the element's index among its siblings (replaces tab_element.index())
    var index = Array.prototype.indexOf.call(tab_element.parentNode.children, tab_element);

    if (index !== -1 && typeof plan_swiper_custom.slideTo === 'function') {
        plan_swiper_custom.slideTo(index, 500, true);
    }
}

// Data Handling Functions
function getSubscriptionVariantData(subscription_tier, subscription_frequency) {
    var variants = {
        "platinum": {
            "on_demand": {
                'sku': 'watch-gang-platinum-sni-od',
                'selling_plan': null
            },
            "quarterly": {
                'sku': 'watch-gang-platinum-sni-q',
                'selling_plan': '585531439'
            },
            "monthly": {
                'sku': 'watch-gang-platinum-sni-1',
                'selling_plan': '585498671'
            }
        },
        "black": {
            "on_demand": {
                'sku': 'watch-gang-black-sni-od',
                'selling_plan': null
            },
            "quarterly": {
                'sku': 'watch-gang-black-sni-q',
                'selling_plan': '585465903'
            },
            "monthly": {
                'sku': 'watch-gang-black-sni-1',
                'selling_plan': '58533135'
            }
        },
        "original": {
            "on_demand": {
                'sku': 'watch-gang-original-sni-od',
                'selling_plan': null
            },
            "quarterly": {
                'sku': 'watch-gang-original-sni-q',
                'selling_plan': '585400367'
            },
            "monthly": {
                'sku': 'watch-gang-original-sni-1',
                'selling_plan': '585367599'
            }
        }
    };

    // Normalize input to prevent casing mismatch issues
    var tier = subscription_tier ? String(subscription_tier).toLowerCase().trim() : '';
    var freq = subscription_frequency ? String(subscription_frequency).toLowerCase().trim() : '';

    var variantData = variants[tier]?.[freq];

    if (!variantData) {
        console.error("Unable to get product variant ID for selected subscription: " + subscription_tier + ' ' + subscription_frequency);
        return false;
    }

    return variantData;
}

function addSubscriptionToCart(variant, coupon_code, baseUrl) {
    if (!variant || !variant.sku) {
        console.error("Invalid variant passed to addSubscriptionToCart");
        return;
    }

    // Default to '/checkout/' if missing or empty
    var urlBase = baseUrl || '/checkout/';
    
    // Ensure urlBase ends with a slash before appending the SKU
    if (!urlBase.endsWith('/')) {
        urlBase += '/';
    }

    var checkoutUrl = urlBase + encodeURIComponent(variant.sku);

    if (coupon_code) {
        checkoutUrl += '?coupon=' + encodeURIComponent(coupon_code);
    }

    window.location.href = checkoutUrl;
}

// Initialization logic
document.addEventListener('DOMContentLoaded', function () {
    // Shared state array for tracking inner card swipers
    var card_swipers_group = [];

    // --- Context Check Helper ---
    function isQuizSubCardContext(element) {
        return element.closest('#QuizContainer') !== null;
    }

    // --- Height Equalization Helper ---
    function equalizeCardHeights() {
        if (typeof window.equalizeCardHeights === 'function') {
            window.equalizeCardHeights();
        }
    }

    // --- Autoplay Management Helper ---
    function manageCarouselAutoplay(group) {
        if (typeof window.manageCarouselAutoplay === 'function') {
            window.manageCarouselAutoplay(group);
        }
    }

    // --- Helper to Init Swiper for a Specific Container ---
    function initPlanSwiper(selector, custom) {
        var containerEl = document.querySelector(selector);
        if (!containerEl) return null;

        var swiperContainer = containerEl.querySelector('.swiper-container');
        if (!swiperContainer) return null;

        var instance = new Swiper(swiperContainer, {
            initialSlide: 1, // Always start on middle/Black tier
            centeredSlides: true,
            slidesPerView: 1.1,
            spaceBetween: 16,
            observer: true,
            observeParents: true,
            breakpoints: {
                640: { slidesPerView: 1.5, centeredSlides: true, spaceBetween: 20 },
                768: { slidesPerView: 2.2, centeredSlides: false, spaceBetween: 20 },
                1024: { slidesPerView: 3, centeredSlides: false, spaceBetween: 20 }
            },
            on: {
                init: function () {
                    var sw = this;

                    // Remove 'selected' from all subcards within this container
                    containerEl.querySelectorAll('.SubCard').forEach(function (card) {
                        card.classList.remove('selected');
                    });

                    // Default to Black tier selected
                    var blackInput = containerEl.querySelector('input[name="subscription_tier"][value="black"]');
                    if (blackInput) {
                        blackInput.checked = true;
                        var parentCard = blackInput.closest('.SubCard');
                        if (parentCard) parentCard.classList.add('selected');
                    } else {
                        var activeSlideCard = containerEl.querySelector('.swiper-slide-active .SubCard');
                        if (activeSlideCard) activeSlideCard.classList.add('selected');
                    }

                    // Init Inner Image Swipers
                    var innerSwiperEls = containerEl.querySelectorAll('.card-image-swiper');
                    if (innerSwiperEls.length > 0) {
                        innerSwiperEls.forEach(function (el) {
                            var innerSwiper = new Swiper(el, {
                                slidesPerView: 1,
                                loop: true,
                                observer: true,
                                observeParents: true,
                                autoplay: {
                                    delay: 2500,
                                    disableOnInteraction: false
                                },
                                navigation: {
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev'
                                }
                            });
                            card_swipers_group.push(innerSwiper);
                        });
                    }

                    manageCarouselAutoplay(card_swipers_group);
                    equalizeCardHeights();
                },
                slideChange: function () {
                    setTimeout(function () {
                        var activeSubCard = containerEl.querySelector('.swiper-slide-active .SubCard');
                        if (activeSubCard) {
                            activeSubCard.click();
                        }
                    }, 50);
                }
            }
        });

        return instance;
    }

    // --- Init Swipers standard / fallback loader ---
    var runInit = function () {
        window.plan_swiper = initPlanSwiper('#wg_shop-plans', false);
        window.plan_swiper_custom = initPlanSwiper('#wg_shop-plans-custom', true);

        // Final fallback equalization
        setTimeout(equalizeCardHeights, 100);
    };

    if (window.Swiper) {
        runInit();
    } else {
        if (typeof requireCSS === 'function' && typeof requireJS === 'function') {
            requireCSS('https://unpkg.com/swiper@6.5.7/swiper-bundle.min.css');
            requireJS('https://unpkg.com/swiper@6.5.7/swiper-bundle.min.js', runInit);
        }
    }

    // --- Window Resize Handler ---
    window.addEventListener('resize', function () {
        setTimeout(equalizeCardHeights, 100);
    });

    // --- Slide Up / Slide Down Animation Helpers (Replaces jQuery Slide Effects) ---
    function slideDown(element, duration) {
        duration = duration || 300;
        element.style.removeProperty('display');
        let display = window.getComputedStyle(element).display;
        if (display === 'none') display = 'block';
        element.style.display = display;
        let height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0px';
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
        element.style.marginTop = '0px';
        element.style.marginBottom = '0px';
        element.offsetHeight; // Force reflow
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        window.setTimeout(function () {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
        }, duration);
    }

    function slideUp(element, duration) {
        duration = duration || 300;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        element.offsetHeight; // Force reflow
        element.style.overflow = 'hidden';
        element.style.height = '0px';
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
        element.style.marginTop = '0px';
        element.style.marginBottom = '0px';
        window.setTimeout(function () {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
        }, duration);
    }

    // --- Global Event Delegation ---
    document.body.addEventListener('click', function (e) {
        var target = e.target;

        // 1. Handle SubCard Selection
        var subCard = target.closest('.SubCard');
        if (subCard && !target.closest('.SubCard__ButtonPrimary') && !target.closest('.SubCard__FreqButton') && !target.closest('.SubCard__ContinueArrow')) {
            if (isQuizSubCardContext(subCard)) return;

            var wrapper = subCard.closest('#wg_shop-plans, #wg_shop-plans-custom');
            if (wrapper) {
                wrapper.querySelectorAll('.SubCard').forEach(function (card) {
                    card.classList.remove('selected');
                });
                subCard.classList.add('selected');

                var radioInput = subCard.querySelector('input[type="radio"][name="subscription_tier"]');
                if (radioInput) radioInput.checked = true;

                var coupon = subCard.getAttribute('data-coupon');
                if (coupon !== null && coupon !== undefined) {
                    var form = subCard.closest('form');
                    if (form) {
                        var couponInput = form.querySelector('input[name="coupon_code"]');
                        if (couponInput) couponInput.value = coupon;
                    }
                }

                manageCarouselAutoplay(card_swipers_group);
            }
        }

        // 2. Handle "Start with" Primary Button
        var btnPrimary = target.closest('.SubCard__ButtonPrimary');
        if (btnPrimary) {
            if (isQuizSubCardContext(btnPrimary)) return;
            e.preventDefault();

            var card = btnPrimary.closest('.SubCard');
            var wrapper = card ? card.closest('#wg_shop-plans, #wg_shop-plans-custom') : null;

            if (wrapper && card) {
                wrapper.querySelectorAll('.SubCard').forEach(function (otherCard) {
                    if (otherCard !== card) {
                        otherCard.classList.remove('selected');

                        var otherBtn = otherCard.querySelector('.SubCard__ButtonPrimary');
                        if (otherBtn) otherBtn.classList.remove('active');

                        var otherFreq = otherCard.querySelector('.SubCard__FrequencySelector');
                        if (otherFreq) slideUp(otherFreq, 200);
                    }
                });
            }

            if (card && !card.classList.contains('selected')) {
                // Programmatically select card
                card.click();
            }

            btnPrimary.classList.add('active');

            var freqSelector = card ? card.querySelector('.SubCard__FrequencySelector') : null;
            if (freqSelector) slideDown(freqSelector, 200);
        }

        // 3. Handle Frequency Button Click
        var freqBtn = target.closest('.SubCard__FreqButton');
        if (freqBtn) {
            if (isQuizSubCardContext(freqBtn)) return;
            e.stopPropagation();
            e.preventDefault();

            var card = freqBtn.closest('.SubCard');
            if (card) {
                card.querySelectorAll('.SubCard__FreqButton').forEach(function (btn) {
                    btn.classList.remove('selected');
                    btn.classList.add('muted');
                });
                freqBtn.classList.remove('muted');
                freqBtn.classList.add('selected');

                var continueArrow = card.querySelector('.SubCard__ContinueArrow');
                if (continueArrow) {
                    continueArrow.classList.add('visible');
                    continueArrow.style.display = 'flex';
                }
            }
        }

        // 4. Handle Continue Arrow Click
        var continueArrow = target.closest('.SubCard__ContinueArrow');
        if (continueArrow) {
            if (isQuizSubCardContext(continueArrow)) return;
            e.preventDefault();
            e.stopPropagation();

            var card = continueArrow.closest('.SubCard');
            if (card) {
                var form = card.closest('form');
                var selectedFreqBtn = card.querySelector('.SubCard__FreqButton.selected');
                var selectedFreq = selectedFreqBtn ? selectedFreqBtn.getAttribute('data-frequency') : null;

                if (selectedFreq && form) {
                    var freqInput = form.querySelector('input[name="subscription_frequency"]');
                    if (freqInput) freqInput.value = selectedFreq;

                    // Trigger form submit directly or standard dispatch event
                    if (typeof form.requestSubmit === 'function') {
                        form.requestSubmit();
                    } else {
                        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                    }
                } else {
                    alert('Please select a frequency.');
                }
            }
        }
    });

    // --- Form Submit Handling ---
    function handleFormSubmit(event) {
        event.preventDefault();
        var form = event.target;

        var formData = new FormData(form);
        var subscription_data = {};

        formData.forEach(function (value, key) {
            subscription_data[key] = value;
        });

        if (typeof getSubscriptionVariantData === 'function' && typeof addSubscriptionToCart === 'function') {
            var variant = getSubscriptionVariantData(subscription_data.subscription_tier, subscription_data.subscription_frequency);
            if (variant) {
                var baseUrl = form.getAttribute('data-checkout-url');
                addSubscriptionToCart(variant, subscription_data.coupon_code, baseUrl);
            }
        }
        return false;
    }

    var formStandard = document.getElementById('subscriptions_form');
    var formCustom = document.getElementById('subscriptions_form_custom');

    if (formStandard) formStandard.addEventListener('submit', handleFormSubmit);
    if (formCustom) formCustom.addEventListener('submit', handleFormSubmit);
});
